<script lang="ts">
  import { ArrowUpRight } from "lucide-svelte";
  import { onMount } from "svelte";
  import { slide } from "svelte/transition";
  import { Hamburger } from "svelte-hamburgers";

  import footerLogo from "$lib/assets/marketing/llm-almanac/footer-logo.png";
  import logo from "$lib/assets/marketing/llm-almanac/logo.png";
  import { mediaQueryStore } from "$lib/media-queries";
  import NavLink from "./NavLink.svelte";
  import { setClientWidth } from "./client-width-context";

  let { children } = $props();

  let isMenuOpen = $state(false);
  const mobile = mediaQueryStore("(max-width: 1024px)");
  let loading = $state(true);
  onMount(() => {
    loading = false;
  });

  let widthState = $state({ width: 0 });
  setClientWidth(widthState);
</script>

<svelte:head>
  <link rel="stylesheet" href="https://use.typekit.net/pgg5ill.css" />
  <style lang="postcss">
    :root {
      color-scheme: light !important;
    }

    body {
      @apply overflow-x-hidden !bg-transparent;
      background-image:
        linear-gradient(rgba(252, 252, 252, 0.98), rgba(252, 252, 252, 0.98)),
        url("https://modal-cdn.com/llm-almanac/paper-bg-heavy.png");
    }
  </style>
</svelte:head>

<main
  class="font-guyot font-light text-lg text-almanac-dark-green min-h-screen"
>
  <div class="grid grid-cols-[1fr]">
    <div
      class={[
        "sticky z-10 top-0 lg:relative flex flex-col",
        "bg-paper-img lg:bg-transparent",
      ]}
    >
      <!-- Logo and navigation -->
      <div
        class="flex items-center justify-between border-b border-almanac-dark-green/30 lg:border-none py-4 px-2 lg:py-4 lg:px-6"
      >
        <a
          class="block relative left-1/2 -translate-x-1/2 flex flex-col items-center"
          href="/llm-almanac/advisor"
        >
          <img
            src={logo}
            alt="LLM Engineer's Almanac"
            class="lg:h-[88px] h-[60px]"
          />
        </a>
        <div class="lg:hidden">
          <Hamburger
            --color="#144236"
            --layer-width="20px"
            --layer-height="3px"
            --layer-spacing="4px"
            bind:open={isMenuOpen}
          />
        </div>
      </div>
      {#if isMenuOpen || !$mobile}
        <div
          class={[
            "lg:flex flex-1 flex-col gap-2",
            "border-b border-almanac-dark-green/30 lg:border-none",
            "absolute lg:static bottom-0 translate-y-full lg:translate-y-0",
            "left-0 right-0 p-4 lg:p-0",
            "bg-paper-img lg:bg-transparent",
            "text-base",
          ]}
          class:hidden={loading}
          class:flex={!loading}
          transition:slide
        >
          <div class="hidden lg:flex flex-col gap-2">
            <hr class="" />
          </div>
          <!-- svelte-ignore a11y_click_events_have_key_events -->
          <!-- svelte-ignore a11y_no_static_element_interactions -->
          <div
            class="flex flex-col lg:flex-row gap-4 lg:gap-8 text-lg font-medium justify-center relative"
            onclick={(e) => {
              if (e.target instanceof HTMLElement && e.target.closest("a")) {
                isMenuOpen = false;
              }
            }}
          >
            <NavLink slug="advisor">Advisor</NavLink>
            <NavLink slug="summary">Executive Summary</NavLink>
            <NavLink slug="how-to-benchmark">How to Benchmark</NavLink>
            <p
              class="lg:absolute right-4 lg:bottom-unset text-almanac-dark-green/80"
            >
              Powered by
              <a
                href="https://modal.com"
                target="_blank"
                class="underline underline-offset-[3px] decoration-[1px] hover:text-almanac-dark-green transition-colors inline-flex items-center"
                >Modal <ArrowUpRight class="inline w-4 h-4 -mt-0.5" /></a
              >
            </p>
          </div>
          <div class="hidden lg:flex flex-col gap-2">
            <hr class="" />
          </div>
        </div>
      {/if}
    </div>

    <div
      class="min-w-0 mt-6 max-w-[calc(min(100%,1000px)-4rem)] justify-self-center"
      bind:clientWidth={widthState.width}
    >
      {@render children?.()}
    </div>

    <div class="h-[200px] grid grid-cols-[1fr_auto_1fr] gap-4 items-center">
      <hr class="border-t-[2px]" />
      <img src={footerLogo} alt="" class="w-[260px] max-w-[40vw]" />
      <hr class="border-t-[2px]" />
    </div>
  </div>
</main>

<style lang="postcss">
  hr {
    @apply border-almanac-dark-green/30;
  }

  .bg-paper-img {
    background-image:
      linear-gradient(rgba(252, 252, 252, 0.98), rgba(252, 252, 252, 0.98)),
      url("https://modal-cdn.com/llm-almanac/paper-bg-heavy.png");
  }
</style>
